import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface DomainBadgeProps {
    domain?: string;
}

/**
 * Renders the human/vet domain of a conversation. Records written before the vet
 * domain shipped carry no domain and are read as "human" by the backend, so an
 * empty value here only ever means the field was not projected.
 */
export const DomainBadge = ({ domain }: DomainBadgeProps) => {
    const { t } = useTranslation();

    if (domain !== "human" && domain !== "vet") {
        return null;
    }

    return (
        <Badge color={domain === "vet" ? "teal" : "gray"} variant="light" size="sm" radius="sm">
            {t(`domain.${domain}`)}
        </Badge>
    );
};
